module.exports = __webpack_public_path__ + "static/media/15.865cd589.png";